// TODO: PM-supplied final value
export const SUPPORT_EMAIL = 'support@bizhaven.com';
